import _ from "lodash";
import { useQuery } from "react-query";

import { autoChecklistService } from "services";

const mapData = (originalOrRerun: {
	[key: string]: any;
}): { [key: string]: any } | null => {
	const addTimeStampAndFieldLength = matches =>
		matches?.map(match => ({
			...match,
			date_to_sort: new Date(match.date).getTime(),
			matched_fields_length: match.matched_fields.length,
		}));

	return _.isEmpty(originalOrRerun)
		? null
		: {
				...originalOrRerun,
				inquiry_matches: addTimeStampAndFieldLength(
					originalOrRerun?.inquiry_matches,
				),
				merchant_matches: addTimeStampAndFieldLength(
					originalOrRerun?.merchant_matches,
				),
		  };
};

const useMatchResultQuery = ({
	id,
	enabled = true,
}: {
	id: number;
	enabled?: boolean;
}) =>
	useQuery(["matchResult", id], () => autoChecklistService.getMatch(id), {
		retry: 0,
		cacheTime: 0,
		enabled: enabled && !!id,
		select: (data: { [key: string]: any }): { [key: string]: any } => ({
			...data,
			original: mapData(data.original),
			rerun: mapData(data.rerun),
		}),
	});

export default useMatchResultQuery;
